import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { DashboardPageProps } from '../../../lib/dashboard-page';
import { AuthLayout } from '../components/auth-layout';
import { AuthLogo } from '../components/auth-logo';
import { ChecklistItem } from '../components/checklist-item';
import { RegisterForm } from '../components/register-form';
import { ReturnToLoginLink } from '../components/return-to-login-link';

const PAGE = 'features:auth.pages.partner_register_page' satisfies I18nPrefix;

export function PartnerRegisterPage({ handlers }: DashboardPageProps) {
  const { navigationHandler } = handlers;

  return (
    <AuthLayout>
      <div className="sm:mx-auto sm:w-full sm:max-w-lg lg:max-w-5xl">
        <AuthLogo className="h-9 w-auto lg:hidden" />
        <div className="flex flex-wrap lg:flex-nowrap lg:justify-between">
          <div className="order-last mt-12 mb-4 min-w-full flex-1 lg:order-0 lg:mt-20 lg:mb-0 lg:block lg:min-w-0 lg:flex-auto">
            <AuthLogo className="mb-12 hidden h-9 w-auto lg:block" />
            <dl className="space-y-7 sm:w-3/4 sm:max-w-lg md:grid md:grid-cols-1 md:gap-x-8 md:gap-y-10 md:space-y-0">
              <h2 className="mb-8 block font-bold text-gray-900 text-xl lg:hidden">
                {t(`${PAGE}.checklist_heading`)}
              </h2>
              <ChecklistItem
                title={t(`${PAGE}.checklist.support.title`)}
                description={t(`${PAGE}.checklist.support.description`)}
              />
              <ChecklistItem
                title={t(`${PAGE}.checklist.slack.title`)}
                description={t(`${PAGE}.checklist.slack.description`)}
              />
              <ChecklistItem
                title={t(`${PAGE}.checklist.sandbox.title`)}
                description={t(`${PAGE}.checklist.sandbox.description`)}
              />
            </dl>
          </div>
          <div className="order-1 mx-auto min-w-full max-w-lg flex-1 lg:order-0 lg:w-2/4 lg:min-w-0 lg:flex-auto">
            <div className="mt-8 rounded-lg bg-white p-10 shadow-xl sm:p-14">
              <div>
                <h2 className="mb-4 font-bold text-gray-900 text-xl sm:text-xl">
                  {t(`${PAGE}.heading`)}{' '}
                  <span className="text-indigo-500">{t(`${PAGE}.heading_highlight`)}</span>
                </h2>
                <p className="max-w mt-2 text-gray-600 text-sm">{t(`${PAGE}.description`)}</p>
              </div>

              <div className="mt-6">
                <RegisterForm handlers={handlers} registerType="partner" />
              </div>
            </div>
            <ReturnToLoginLink
              navigationHandler={navigationHandler}
              className="max-w pt-8 text-gray-600 text-sm md:pb-12"
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
